import React from 'react';
import { EDataTransformDimensionName } from '@src/common/constant/enum';
import {
  CommonCellRenderer,
  DateHeaderRender,
  NameCellRenderer,
  SelectableHeaderRenderer,
  StatusCellRenderer,
} from '@src/emp-3.0/components/Management';
import { deploymentValuesMap } from '@src/emp-3.0/components/DeploymentDrawer/constants';
import { formatTimestamp } from '@src/emp-3.0/utils';

export const generateCommonColumn = (props?: any) => {
  return {
    title: 'Action Blockers',
    dataIndex: 'action_inhibitors',
    key: 'action_inhibitors',
    render: (value) =>
      CommonCellRenderer({
        cellData: value,
      }),
    ...props,
  };
};

export const generateNameColumn = (props?: any) => {
  return {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (value, record) =>
      NameCellRenderer({
        cellData: EDataTransformDimensionName[value] ?? value,
        rowData: record,
        column: { style: { color: 'rgba(0, 0, 0, 0.88)', fontWeight: 600 } },
      }),
    ...props,
  };
};

export const generateStatusColumn = (props?: any) => {
  return {
    title: SelectableHeaderRenderer({
      column: {
        title: 'Status',
        dataKey: 'status',
        headerStyle: { padding: 0 },
        ...props?.column,
      },
    }),
    dataIndex: 'status',
    key: 'status',
    render: (value) => StatusCellRenderer({ cellData: value }),
  };
};

export const generateTypeColumn = (props?: any) => {
  return {
    title: SelectableHeaderRenderer({
      column: {
        title: 'Type',
        dataKey: 'type',
        headerStyle: { padding: 0 },
        ...props?.column,
      },
    }),
    dataIndex: 'type',
    key: 'type',
    render: (value) => <span>{deploymentValuesMap[value]}</span>,
    ...props,
  };
};

export const generateUserColumn = (props?: any) => {
  return {
    title: SelectableHeaderRenderer({
      column: {
        title: 'Latest updated by',
        dataKey: 'last_updated_by',
        headerStyle: { padding: 0 },
        ...props?.column,
      },
    }),
    dataIndex: 'last_updated_by',
    key: 'last_updated_by',
    ...props,
  };
};

export const generateDateColumn = (props?: any) => {
  return {
    title: DateHeaderRender({
      column: {
        title: 'Latest updated at',
        dataKey: 'edited_time',
        headerStyle: { padding: 0 },
        ...props?.column,
      },
    }),
    dataIndex: 'edited_time',
    key: 'edited_time',
    render: (value) => <div>{formatTimestamp(value)}</div>,
    ...props,
  };
};
